import CurrencyCell from "../components/CurrencyCell";
import DiscountCell from "../components/DiscountCell";
import { cellStyle, currencyFormat } from "../helpers";
import PercentageCell from "../components/PercentageCell";
import { daysInCurrentMonth } from "../helpers";
import CustomButtonComponent from "./CustomButtonComponent";

const schemeColDef = [
  {
    headerName: "",
    headerClass: "primary",
    children: [
      {
        headerClass: "primary",
        field: "Region",
        width: 130,
        //editable: true,
        enableRowGroup: true,
        enablePivot: true,
        rowGroup: true,
        pinned: true,
        filter: "text",
        cellRenderer: "agGroupCellRenderer",
      },
      {
        headerClass: "primary",
        field: "Country",
        width: 130,
        //editable: true,
        enableRowGroup: true,
        enablePivot: true,
        rowGroup: true,
        pinned: true,
        filter: "text",
        cellRenderer: "agGroupCellRenderer",
      },
      {
        headerClass: "primary",
        field: "Warehouse",
        width: 130,
        //editable: true,
        enableRowGroup: true,
        enablePivot: true,
        pinned: false,
        editable: true,
        filter: "text",
        cellRenderer: "agGroupCellRenderer",
      },

      {
        headerClass: "primary",
        headerName: "Channel",
        field: "OutletType",
        enableRowGroup: true,
        enablePivot: true,
        rowGroup: true,
        width: 120,
        pinned: true,
        filter: "text",
        cellRenderer: "agGroupCellRenderer",
      },
      {
        headerClass: "primary",
        headerName: "Pricelist",
        field: "Pricelist",
        enableRowGroup: true,
        enablePivot: true,
        rowGroup: true,
        width: 120,
        pinned: true,
        filter: "text",
        cellRenderer: "agGroupCellRenderer",
      },
      {
        headerClass: "primary",
        headerName: "Product",
        field: "Product_Name",
        enableRowGroup: true,
        enablePivot: true,
        rowGroup: true,
        width: 120,
        pinned: true,
        filter: "text",
        cellRenderer: "agGroupCellRenderer",
      },
      // {
      //   headerClass: "primary",
      //   headerName: "MRP",
      //   field: "MRP",
      //   width: 120,
      //   aggFunc: "sum",
      //   //editable: true,
      //   //filter: "text",
      // },

      // {
      //   headerClass: "primary",
      //   headerName: "PTR",
      //   field: "ptr_current",
      //   width: 175,
      //   //filter: "text",
      // },


    ]
  },

  {
    headerName: "LM",
    children: [

      {
        headerClass: "primary",
        headerName: "Rev",
        field: "last_month",
        width: 120,
        aggFunc: "sum",
         enablePivot: true,
         enableValue: true,
        // filter: "text",
        cellRenderer: CurrencyCell,
      },

      {
        headerClass: "primary",
        headerName: "Qty",
        field: "last_month_quantity",
        width: 120,
        aggFunc: "sum",
        enablePivot: true,
        //filter: "text",
        cellRenderer: CurrencyCell,
      },

 {
        headerClass: "primary",
        headerName: "NR",
        width: 120,
        enablePivot: true,
        enableValue: true,
        valueGetter: (params) => {
          if (!params.node.group) {
            const rev = params.data?.last_month || 0;
            const qty = params.data?.last_month_quantity || 0;
            const nr = qty !== 0 ? rev / qty : 0;

            return {
             last_month:rev,
             last_month_quantity:qty,
              toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
            };
          }
        },

        aggFunc: (params) => {
          let revSum = 0;
          let qtySum = 0;

          params.values.forEach((value) => {
            if (value && typeof value === "object") {
              if (value.last_month !== undefined) revSum += value.last_month;
              if (value.last_month_quantity !== undefined) qtySum += value.last_month_quantity;
            }
          });

          const nr = qtySum !== 0 ? revSum / qtySum : 0;
          return {
            last_month: revSum,
            last_month_quantity: qtySum,
            toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
          };
        },
        cellRenderer: (params) => {
          return typeof params.value === "object" && params.value?.toString
            ? params.value.toString()
            : "0.00";
        }
      },
      {
        headerClass: "primary",
        headerName: "Scheme %",
        //field: "lastmonth_schemepercentage",
        width: 120,
        cellRenderer: PercentageCell,
        valueGetter: (params) => {
          if (!params.node.group) {
            const offInv = params.data?.last_month_offinv_plan_cost || 0;
            const inv = params.data?.last_month_oninv_plan_cost || 0;
            const rev = params.data?.m1baserevenue || 0;
            const res= offInv + inv;
            const nr = rev !== 0 ? res / rev : 0;

            return {
             res:res,
             rev:rev,
              toString: () => {
                        return res && rev
                          ? Math.round(nr* 100)
                          : 0;
                      }
            };
          }
        },

        aggFunc: (params) => {
          let revSum = 0;
          let qtySum = 0;

          params.values.forEach((value) => {
            if (value && typeof value === "object") {
              if (value.res !== undefined) revSum += value.res;
              if (value.rev !== undefined) qtySum += value.rev;
            }
          });

          const nr = qtySum !== 0 ? revSum / qtySum : 0;
          return {
             revSum,
             qtySum,
            //toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
            toString: () => {
                        return revSum && qtySum
                          ? Math.round(nr* 100)
                          : 0;
                      }
          };
        },
        cellRenderer: (params) => {
          return typeof params.value === "object" && params.value?.toString
            ? params.value.toString()
            : "0.00";
        }
        //filter: "text",
      },
        {
        headerClass: "primary",
        headerName: "Scheme Qty %",
        //field: "lastmonth_schemepercentage",
        width: 120,
        
        valueGetter: (params) => {
          if (!params.node.group) { 
            const offInv = params.data?.m1basequantityincrement || 0;
            const rev = params.data?.m1basequantity || 0  ;
            const res= offInv;
            const nr = rev !== 0 ? res / rev : 0;

            return {
             res:res,
             rev:rev,
              toString: () => {
                        return res && rev
                          ? Math.round(nr* 100)
                          : 0;
                      }
            };
          }
        },

        aggFunc: (params) => {
          let revSum = 0;
          let qtySum = 0;

          params.values.forEach((value) => {
            if (value && typeof value === "object") {
              if (value.res !== undefined) revSum += value.res;
              if (value.rev !== undefined) qtySum += value.rev;
            }
          });

          const nr = qtySum !== 0 ? revSum / qtySum : 0;
          return {
             revSum,
             qtySum,
            //toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
            toString: () => {
                        return revSum && qtySum
                          ? Math.round(nr* 100)
                          : 0;
                      }
          };
        },
        valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
        //filter: "text",
        //cellRenderer: PercentageCell,
      },
      {
        headerClass: "primary",
        headerName: "Rev Impact",
        field: "last_month_scheme_impact",
        width: 120,
        aggFunc: "sum",
        //filter: "text",
        cellRenderer: CurrencyCell,
      },
      {
        headerClass: "primary",
        headerName: "Cost Plan",
        width: 120,
        //enableValue: true, // Needed for pivot mode
        enablePivot: true,
        enableValue: true,
        valueGetter: (params) => {
          const offInv = params.data?.last_month_offinv_plan_cost || 0;
          const inv = params.data?.last_month_oninv_plan_cost || 0;
          return offInv + inv;
        },
        aggFunc: "sum",
        cellRenderer: CurrencyCell
      },
      {
        headerClass: "primary",
        headerName: "Cost Act",
        width: 120,
        enablePivot: true,
        enableValue: true,
        valueGetter: (params) => {
          const offInv = params.data?.last_month_offinv_act_cost || 0;
          const inv = params.data?.last_month_inv_act_cost || 0;
          return offInv + inv;
        },
        aggFunc: "sum",
        cellRenderer: CurrencyCell
      },


    ]
  },

  {
    headerName: "CM",
    children: [

      {
        headerClass: "primary",
        headerName: "Rev",
        field: "current_month_outlook",
        width: 120,
        aggFunc: "sum",
        // filter: "text",
        cellRenderer: CurrencyCell,
        enablePivot: true,
      },

      {
        headerClass: "primary",
        headerName: "Qty",
        field: "current_month_outlook_quantity",
        width: 120,
        aggFunc: "sum",
        cellRenderer: CurrencyCell,
        enablePivot: true,
        //filter: "text",
      },

      {
        headerClass: "primary",
        headerName: "NR",
        width: 120,
        enablePivot: true,
        enableValue: true,
        valueGetter: (params) => {
          if (!params.node.group) {
            const rev = params.data?.current_month_outlook || 0;
            const qty = params.data?.current_month_outlook_quantity || 0;
            const nr = qty !== 0 ? rev / qty : 0;

            return {
             current_month_outlook:rev,
             current_month_outlook_quantity:qty,
              toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
            };
          }
        },

        aggFunc: (params) => {
          let revSum = 0;
          let qtySum = 0;

          params.values.forEach((value) => {
            if (value && typeof value === "object") {
              if (value.current_month_outlook !== undefined) revSum += value.current_month_outlook;
              if (value.current_month_outlook_quantity !== undefined) qtySum += value.current_month_outlook_quantity;
            }
          });

          const nr = qtySum !== 0 ? revSum / qtySum : 0;
          return {
            current_month_outlook: revSum,
            current_month_outlook_quantity: qtySum,
            toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
          };
        },
        cellRenderer: (params) => {
          return typeof params.value === "object" && params.value?.toString
            ? params.value.toString()
            : "0.00";
        }
      },
      {
        headerClass: "primary",
        headerName: "Scheme %",
        //field: "lastmonth_schemepercentage",
        width: 120,
        
        valueGetter: (params) => {
          if (!params.node.group) { 
            const offInv = params.data?.current_month_offinv_plan_cost || 0;
            const inv = params.data?.current_month_oninv_plan_cost || 0;
            const rev = params.data?.mbaserevenue || 0  ;
            const res= offInv + inv;
            const nr = rev !== 0 ? res / rev : 0;

            return {
             res:res,
             rev:rev,
              toString: () => {
                        return res && rev
                          ? Math.round(nr* 100)
                          : 0;
                      }
            };
          }
        },

        aggFunc: (params) => {
          let revSum = 0;
          let qtySum = 0;

          params.values.forEach((value) => {
            if (value && typeof value === "object") {
              if (value.res !== undefined) revSum += value.res;
              if (value.rev !== undefined) qtySum += value.rev;
            }
          });

          const nr = qtySum !== 0 ? revSum / qtySum : 0;
          return {
             revSum,
             qtySum,
            //toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
            toString: () => {
                        return revSum && qtySum
                          ? Math.round(nr* 100)
                          : 0;
                      }
          };
        },
        valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
        //filter: "text",
        //cellRenderer: PercentageCell,
      },
      {
        headerClass: "primary",
        headerName: "Scheme Qty %",
        //field: "lastmonth_schemepercentage",
        width: 120,
        
        valueGetter: (params) => {
          if (!params.node.group) { 
            const offInv = params.data?.mbasequantityincrement || 0;
            const rev = params.data?.mbasequantity || 0  ;
            const res= offInv;
            const nr = rev !== 0 ? res / rev : 0;

            return {
             res:res,
             rev:rev,
              toString: () => {
                        return res && rev
                          ? Math.round(nr* 100)
                          : 0;
                      }
            };
          }
        },

        aggFunc: (params) => {
          let revSum = 0;
          let qtySum = 0;

          params.values.forEach((value) => {
            if (value && typeof value === "object") {
              if (value.res !== undefined) revSum += value.res;
              if (value.rev !== undefined) qtySum += value.rev;
            }
          });

          const nr = qtySum !== 0 ? revSum / qtySum : 0;
          return {
             revSum,
             qtySum,
            //toString: () => isFinite(nr) ? nr.toFixed(2) : "0.00"
            toString: () => {
                        return revSum && qtySum
                          ? Math.round(nr* 100)
                          : 0;
                      }
          };
        },
        valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
        //filter: "text",
        //cellRenderer: PercentageCell,
      },
       {
        headerClass: "primary",
        headerName: "Rev Impact",
        field: "current_month_scheme_impact",
        width: 120,
        aggFunc: "sum",
        //filter: "text",
        cellRenderer: CurrencyCell,
      },
      {
        headerClass: "primary",
        headerName: "Cost Plan",
        width: 120,
        enablePivot: true,
        
        valueGetter: (params) => {
          const offInv = params.data?.current_month_offinv_plan_cost || 0;
          const inv = params.data?.current_month_oninv_plan_cost || 0;
          return offInv + inv;
        },
        aggFunc: "sum",
        // aggFunc: (params) => {
        //   console.log("values",params)
        //   let total = 0;
        //   if (Array.isArray(params.values)) {
        //     params.values.forEach(item => {
        //       if (item && typeof item === 'object') {
        //         total += (item.offInv || 0) + (item.inv || 0);
        //       }
        //     });
        //   }
        //   return total;
        // },
        cellRenderer: CurrencyCell
      },
      {
        headerClass: "primary",
        headerName: "Cost Act",
        width: 120,
        enablePivot: true,
        aggFunc: "sum",
        valueGetter: (params) => {
          const offInv = params.data?.current_month_offinv_act_cost || 0;
          const inv = params.data?.current_month_inv_act_cost || 0;
           return offInv + inv;
        },
        cellRenderer: CurrencyCell
      }


    ]
  },
];

export { schemeColDef };
